// extracted by mini-css-extract-plugin
module.exports = {"Banner":"LYRVBanner_Banner__uw_JH","BannerText":"LYRVBanner_BannerText__fv5jO","Link":"LYRVBanner_Link__58F57"};